module.exports = __webpack_public_path__ + "static/media/2.02b19ffb.jpg";